module.exports = __webpack_public_path__ + "img/6.2719e64a.jpg";